module.exports = __webpack_public_path__ + "static/media/support-keyboard.134a3d2c.svg";